/* eslint-disable camelcase */
import { People } from '@mui/icons-material'
import { Accordion, AccordionDetails, Button, Dialog, DialogActions, DialogContent, Grid, Stack, Tooltip, Typography } from '@mui/material'
import { POINT_STATUS_DECLARATION } from 'agriAdministration/constants/AgriConstants'
import Checkbox from 'components/forms/Checkbox'
import { AccordionTitle } from 'components/styled/Accordions'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import DtoExploitation from 'exploitations/dto/DtoExploitation'
import DtoInstallation from 'installation/dto/installation/DtoInstallation'
import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoDeclaration from 'survey/dto/DtoDeclaration'
import { hasValue } from 'utils/NumberUtil'
import { getI18nTitleData } from 'utils/StringUtil'

const ModalAddPoint = ({
    open,
    toggleModal,
    addPoint,
    selectedPoints,
    installationPoints,
    declaration,
}) => {
    const [listPoints, setListPoints] = useState(selectedPoints)
    const noUsePoints = installationPoints.filter((p) => p.status === POINT_STATUS_DECLARATION.REMOVED || !p.status)
    // const deletePoints = installationPoints.filter((p) => p.status === 3)

    const {
        exploitation,
        exploitationsExportFullData,
        citiesIndex,
    } = useSelector(store => ({
        exploitation: store.AgriReducer.exploitation,
        exploitationsExportFullData: store.AgriReducer.exploitationsExportFullData,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const handleAddPoint = (p) => {
        const pointsFiltered = listPoints.filter((point) => point.idInstallation !== p.id)
        if (listPoints.find((point) => point.idInstallation === p.id && point.stateCode === 1)) {
            setListPoints(pointsFiltered)
        } else {
            const linkPoint = listPoints.find((point) => point.idInstallation === p.id) || {}
            const newPoints = [
                ...pointsFiltered,
                {
                    ...linkPoint,
                    idSurvey: declaration.idSurvey,
                    idExploitation: declaration.idExploitation,
                    idInstallation: p.id,
                    stateCode: 1,
                    link_usages: linkPoint.link_usages || [],
                },
            ]
            setListPoints(newPoints)
        }
    }

    const cancelAndClose = () => {
        setListPoints(selectedPoints)
        addPoint(selectedPoints)
        toggleModal()
    }

    const saveAndClose = () => {
        addPoint(listPoints)
        toggleModal()
    }

    const isSelected = (point) => {
        return listPoints.find((p) => p.idInstallation === point.id && p.stateCode === POINT_STATUS_DECLARATION.USED)
    }

    const getFilteredPoints = (points) => {
        return points.filter((p) => !selectedPoints.find((point) => point.idInstallation === p.id))
    }

    const getLineRepartition = (link) => {
        const exploitationFound = exploitationsExportFullData.find((e) => e.idExploitation === link.idExploitation) || {}
        return (
            <>
                <span>{exploitationFound.codification} : {hasValue(link.distribution) ? `${link.distribution} %` : i18n.unknown}</span><br />
            </>
        )
    }

    const item = (city, point) => {
        const linkPoint = exploitation.link_samplings.find((l) => l.idInstallation === point.idInstallation) || {}
        const link_shared = linkPoint.link_shared || []
        const isShared = link_shared.filter((ls) => ls.idExploitation !== exploitation.idExploitation).length > 0
        const total = link_shared.reduce((acc, l) => acc + (l.distribution || 0), 0)
        const tooltip = (
            <>
                {link_shared.map((p) => getLineRepartition(p))}
                <Typography sx={{ fontWeight: 'bold' }} >{i18n.total} : {`${total} %`}</Typography>
            </>
        )
        return (
            <Stack spacing={0.5}>
                <Typography sx={{ fontWeight: 'bold' }}>{city ? city.name : ''}</Typography>
                {point.location || ''}
                <Grid container alignItems='center' sapcing={1}>
                    {`${point.code || ''} ${`- ${point.parcel || ''} ${point.section || ''}${point.name ? ` - ${point.name}` : ''}`}`}
                    {isShared && (
                        <Tooltip title={tooltip}>
                            <People />
                        </Tooltip>
                    )}
                </Grid>
            </Stack>
        )
    }

    const pointsUsed = useMemo(() => selectedPoints.filter((point) => point.stateCode !== POINT_STATUS_DECLARATION.REMOVED && point.stateCode !== POINT_STATUS_DECLARATION.ADJOURNED), [selectedPoints])
    const pointsNotUsed = useMemo(() => getFilteredPoints(noUsePoints), [noUsePoints])
    const pointsAbandonned = useMemo(() => selectedPoints.filter((point) => point.stateCode === POINT_STATUS_DECLARATION.REMOVED), [selectedPoints])
    const pointsAdjourned = useMemo(() => selectedPoints.filter((point) => point.stateCode === POINT_STATUS_DECLARATION.ADJOURNED), [selectedPoints])

    return (
        <Dialog
            fullWidth
            maxWidth='md'
            open={open}
        >
            <DefaultDialogTitle title={i18n.select} onClose={cancelAndClose} />
            <DialogContent>
                <Stack spacing={1}>
                    <Accordion>
                        <AccordionTitle title={`${pointsUsed.length} ${getI18nTitleData(i18n.usedPoint, i18n.usedPoints, pointsUsed)}`} />
                        <AccordionDetails sx={{ padding: 0 }}>
                            {installationPoints.map((p) => {
                                if (pointsUsed.find((point) => point.idInstallation === p.id)) {
                                    const city = citiesIndex[p.townCode]
                                    return (
                                        <Grid key={p.code} container padding={1}>
                                            {item(city, p)}
                                        </Grid>
                                    )
                                }
                                return ''
                            })}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionTitle title={`${pointsAdjourned.length} ${getI18nTitleData(i18n.adjournPoint, i18n.adjournPoints, pointsAdjourned)}`} />
                        <AccordionDetails sx={{ padding: 0 }}>
                            {installationPoints.map((p) => {
                                if (pointsAdjourned.find((point) => point.idInstallation === p.id)) {
                                    const city = citiesIndex[p.townCode]
                                    return (
                                        <Grid key={p.code} container alignItems={'center'} spacing={1} padding={1}>
                                            <Checkbox
                                                checked={isSelected(p)}
                                                onChange={() => handleAddPoint(p)}
                                            />
                                            {item(city, p)}
                                        </Grid>
                                    )
                                }
                                return ''
                            })}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion defaultExpanded>
                        <AccordionTitle title={`${pointsNotUsed.length} ${getI18nTitleData(i18n.noUsedPoint, i18n.noUsedPoints, pointsNotUsed)}`} />
                        <AccordionDetails sx={{ padding: 0 }}>
                            {pointsNotUsed.map((p) => {
                                const city = citiesIndex[p.townCode]
                                return (
                                    <Grid key={p.code} container alignItems='center' spacing={1} padding={1}>
                                        <Checkbox
                                            checked={isSelected(p)}
                                            onChange={() => handleAddPoint(p)}
                                        />
                                        {item(city, p)}
                                    </Grid>
                                )
                            })}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionTitle title={`${pointsAbandonned.length} ${getI18nTitleData(i18n.abandonnedPoint, i18n.abandonnedPoints, pointsAbandonned)}`} />
                        <AccordionDetails sx={{ padding: 0 }}>
                            {installationPoints.map((p) => {
                                if (pointsAbandonned.find((point) => point.idInstallation === p.id)) {
                                    const city = citiesIndex[p.townCode]
                                    return (
                                        <Grid key={p.code} container padding={1}>
                                            {item(city, p)}
                                        </Grid>
                                    )
                                }
                                return ''
                            })}
                        </AccordionDetails>
                    </Accordion>
                </Stack>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'space-between' }}>
                <Button variant='outlined' color='primary' onClick={cancelAndClose}>
                    {i18n.cancel}
                </Button>
                <Button variant='contained' color='primary' onClick={saveAndClose}>
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ModalAddPoint.propTypes = {
    open: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    addPoint: PropTypes.func.isRequired,
    declaration: PropTypes.instanceOf(DtoDeclaration).isRequired,
    exploitation: PropTypes.instanceOf(DtoExploitation).isRequired,
    installationPoints: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallation)).isRequired,
    selectedPoints: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallation)).isRequired,
}

export default ModalAddPoint